__turbopack_context__.v({
  "container": "ExpertImage-module-scss-module__00Kpzq__container",
  "image": "ExpertImage-module-scss-module__00Kpzq__image",
});
